/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-nested-ternary */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import defaultPhoto from 'assets/img/image-placeholder.jpg';
import Img from 'modules/common/components/Img';

function Requirements({ data }) {
  
  const tabList = data || []
  
  const [requirementTab, setRequirementTab] = useState(0);

  const handleChangeRequirementTab = location => () => {
    setRequirementTab(location);
  };

  return (
    <div className="m-3">
      <div className="row mb-3">
        {/* TABS */}
        <div className="col-6">
          <div className="form-wrapper arrow-card">
            {!_.isEmpty(tabList) ? (
              tabList.map((item, i) => (
                <div
                  key={item.id}
                  role="presentation"
                  style={{cursor: "pointer"}}
                  className={`arrow-cell p-3 btn-blank ${i === requirementTab ? 'selected-tab' : ''}`}
                  onClick={handleChangeRequirementTab(i)}
                >
                  <div className="font-weight-bold">
                    {_.get(item, 'attributes.name')}
                  </div>
                  {/* {i === requirementTab ? <div style={{top: "30%"}} className="arrow" /> : ''} */}
                </div>
              ))
            ) : '' }
          </div>
        </div>
        {/* IMAGE HOLDER */}
        <div className="col-6">
          <div className="form-wrapper preview-image">
            {!_.isEmpty(tabList) // CHECK TABLIST IF EMPTY
              ? (
                <React.Fragment>
                  {tabList.map((item, i) => (i === requirementTab ? (
                      !/\.pdf$/i.test(_.get(item, 'attributes.url', '')) ? (
                        <Img
                          key={item.id}
                          src={_.get(item, 'attributes.url')}
                          className="shadow-lg"
                          role="presentation"
                          defaultSrc={defaultPhoto}
                          width="80%"
                          alt=""
                        />
                      ) : (
                        <iframe
                          title='Birth certificate requirements'
                          style={{ width: '100%', height: '400px' }}
                          className='img img-fluid'
                          alt={`requirements_${_.get(item, 'id')}`}
                          src={_.get(item, 'attributes.url')}
                        />
                      )
                    ) : ''
                  ))}
                </React.Fragment>
              ) : ''
            }
          </div>
        </div>
      </div>
    </div>
  );
}

Requirements.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps
  ),
]);


export default enhance(Requirements);
